import { icons } from "../assets/icons";
import ThemeButton from "./themeButton";
import Me from "../assets/pixel_alnick.png";
import Me2 from "../assets/pixel_alnick_giggle.png";
import { useState } from "react";

const Heading = () => {
  const [defaultImg, setDefaultImg] = useState(Me);

  return (
    <div className="flex gap-3 md:mb-7 mb-3">
      <img
        onMouseEnter={() => setDefaultImg(Me2)}
        onMouseLeave={() => setDefaultImg(Me)}
        src={defaultImg}
        alt="Alnick"
        className="rounded-xl h-32 w-32 md:h-40 md:w-40 border dark:border-none mb-4 md:mb-0"
      />
      <div className="flex flex-col gap-1 md:gap-1 flex-grow">
        <div className="flex justify-between items-start flex-wrap gap-2">
          <h1 className="text-2xl font-bold whitespace-nowrap">
            Alnick Clores
          </h1>
          <div className="shrink-0">
            <ThemeButton />
          </div>
        </div>

        <div className="flex items-center gap-1">
          <span>{icons.location}</span>
          <span className="text-sm">Valenzuela, Philippines</span>
        </div>

        <h1 className="text-md font-semibold tracking-wider md:my-3">
          &lt; Full-stack Developer /&gt;
        </h1>

        <div className="flex gap-1">
          <button
            className="flex items-center gap-2 bg-white text-black text-[11px] px-3 py-[7px] md:text-xs md:px-4 md:py-2 rounded-lg font-semibold border dark:bg-black dark:text-white dark:border-gray-500 shadow-sm hover:shadow-md transform transition-all hover:-translate-y-0.5 duration-300 mb-2 md:mb-0"
            onClick={() => window.open("/CLORES_ALNICK-RESUME.pdf", "_blank")}
          >
            <span>{icons.resume}</span>
            <span className="whitespace-nowrap">My Resume</span>
          </button>

          <a
            className="flex items-center gap-2 bg-black text-white text-[11px] px-3 py-[7px] md:text-xs md:px-4 md:py-2 rounded-lg font-semibold border dark:bg-white dark:text-black dark:border-gray-500 shadow-sm hover:shadow-md transform transition-all hover:-translate-y-0.5 duration-300 mb-2 md:mb-0"
            href="mailto:aelnickclores@gmail.com"
          >
            <span>{icons.mail}</span>
            <span className="whitespace-nowrap">Send Email</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Heading;
